import React, { useState, useEffect } from "react";
import { NavLink } from "react-router";
import { Global } from "../helpers/Global";
import { Peticion } from "../helpers/Peticion";

export const Portafolio = () => {

   const [portafolio, setPortafolio] = useState([]);

    const getPortafolio = async () => {
         let { datos } = await Peticion(Global.url + "portafolio/", "GET");
     
         if (datos) {
           setPortafolio(datos.data);
         }
       };
   
        useEffect(() => {
           getPortafolio();
         }, []);

  return (
    <section class="content__page content__portfolio">
      {/* <!-- contenido de about me --> */}
      <header class="portfolio__header">
        <h1 class="portfolio__title">Portafolio</h1>
      </header>
      <nav class="portfolio__navbar">
        <ul class="portfolio__menu">
          <li class="portfolio__option portfolio__option--active">
            <NavLink to="#" class="portfolio__link">
              Todo
            </NavLink>
          </li>
          <li class="portfolio__option">
            <NavLink to="#" class="portfolio__link">
              Cursos
            </NavLink>
          </li>
          <li class="portfolio__option">
            <NavLink to="#" class="portfolio__link">
              Web
            </NavLink>
          </li>
          <li class="portfolio__option">
            <NavLink to="#" class="portfolio__link">
              Redes Sociales
            </NavLink>
          </li>
          <li class="portfolio__option">
            <NavLink to="#" class="portfolio__link">
              Videos
            </NavLink>
          </li>
          <li class="portfolio__option">
            <NavLink to="#" class="portfolio__link">
              Proyectos
            </NavLink>
          </li>
        </ul>
      </nav>
      <section class="portfolio__gallery">
      
          {portafolio.map((portfolio) => {
            return(
                <figure class="gallery__item">
                  <div class="gallery__container-image">
                    <NavLink
                      to= { portfolio.url }
                      target="_blank"
                      class="gallery__link"
                    >
                      <img src={Global.media + portfolio.image} class="gallery__image" alt={portafolio.name} />
                    </NavLink>
                  </div>
                  <figcaption class="gallery__title"> {portfolio.title}</figcaption>
                  <span class="gallery__desc" >{portfolio.description}</span>
                  <i class=  { portfolio.icon + 'gallery__ico' }  ></i>
                  <span class="gallery__category"> {portfolio.category} </span>
                </figure> 
            );
          } )}
         
      </section>
    </section>
  );
};
